/**
 * Select component for insight selection with segmented control and input text;
 * Used for BehavioralEventSelect and ContactPropertySelect
 */
import { Search } from 'ui/icons';
import { InputText, InputTextProps } from 'ui/inputs';
import { SegmentedControlNoSizeProps, SmallSegmentedControl } from 'ui/segmentedControl';
import {
  ALIGNMENT,
  BasicSelectWithNestedChildren,
  RawSelectProps,
  SelectOptionsContainer,
  SelectValueType,
  StickyWrapper,
} from 'ui/selects';
import noop from 'utils/noop';
import { Trigger } from './InsightSelectTrigger';

type InsightSelectProps = {
  selectTestId?: RawSelectProps['data-test'];
  selectPlaceholder: RawSelectProps['placeholder'];
  selectOptions: RawSelectProps['options'];
  onOptionSelect: RawSelectProps<SelectValueType>['onSelect'];
  segmentedControlTestId?: string;
  segmentedControlMode?: string;
  segmentedControlOptions?: SegmentedControlNoSizeProps['options'];
  onSegmentedControlSelect?: SegmentedControlNoSizeProps['onSelect'];
  textInputPlaceholder: InputTextProps['placeholder'];
};

export const InsightSelect = ({
  isDisabled,
  selectTestId = '',
  selectPlaceholder,
  size,
  width,
  selectOptions,
  onOptionSelect,
  segmentedControlTestId = '',
  segmentedControlMode = '',
  segmentedControlOptions = [],
  onSegmentedControlSelect = noop,
  textInputPlaceholder,
}: InsightSelectProps & Omit<RawSelectProps<SelectValueType>, 'options'>) => {
  return (
    <BasicSelectWithNestedChildren
      data-test={selectTestId}
      isDisabled={isDisabled}
      onSelect={onOptionSelect}
      options={selectOptions}
      placeholder={selectPlaceholder}
      horizontalAlignment={ALIGNMENT.RIGHT}
      size={size}
      Trigger={Trigger}
      autoFocusOnInput
      shouldFocusOnFirstElementByDefault={false}
      width={width}
      SelectOptionsContainer={SelectOptionsContainer}
    >
      <StickyWrapper>
        <SmallSegmentedControl
          data-test={segmentedControlTestId}
          value={segmentedControlMode}
          options={segmentedControlOptions}
          onSelect={onSegmentedControlSelect}
          isFullWidth
        />
      </StickyWrapper>
      <InputText
        type="search"
        autoComplete="off"
        id="behavioral-event-input-filter"
        placeholder={textInputPlaceholder}
        Prefix={<Search />}
        value=""
        autoFocus
      />
    </BasicSelectWithNestedChildren>
  );
};
